function string2number(s) {
  // convertit une chaine de caractère contenant un mois en nombre
  // Ex: "Mars" -> 3
  const months = {
    Janvier: 1,
    Février: 2,
    Mars: 3,
    Avril: 4,
    Mai: 5,
    Juin: 6,
    Juillet: 7,
    Aout: 8,
    Septembre: 9,
    Octobre: 10,
    Novembre: 11,
    Décembre: 12,
  };
  return months[s] ?? 0;
}

export default {
  name: "Amaury CURIEL",
  tagline: "Doctorant en informatique",
  project : "Membre du projet [pandag:ANR PAnDAG]",
  description:
    "Je travaille sur de la génération et l'étude de graphes dirigés acycliques ainsi que sur la génération lexicographique d'objets combinatoires plus simples.",
  buttons: {
    contact: "Me contacter",
    cv: "Voir mon CV",
    prenom: "prénom",
    nom: "nom",
  },
  links: {
    pandag : "https://pandag.proj.lip6.fr",
  },
  sections: {
    interests: {
      title: "Centres d’intérêt",
      items: [
        "Graphes dirigés acycliques (DAGs)",
        "BDDs",
        "Génération aléatoire",
        "Algorithmes d'unranking",
        "Partitions d'ensembles",
      ],
    },
    education: {
      title: "Formation",
      items: [
        "Doctorant (Sorbonne Université, LIP6, APR)",
        "Master d'informatique (Sorbonne Université, STL)",
        "Double licence en mathématiques et informatique (Université Paris-Saclay)",
      ],
    },
  },
  homepage: {
    title: "Accueil",
  },
  research: {
    title: "Recherche",
    description:
      "Actuellement en 2ème année de doctorat au sein de l'équipe APR du LIP6 sous la direction d'[sorbonne:Antoine Genitrini], ma thèse " +
      "porte sur l'étude des graphes dirigés acycliques (DAGs). Je suis particulièrement intéressé par les BDDs, une classe de DAGs résultant de la compression de fonctions booléennes. Mon " +
      "objectif est d'étudier leurs distributions ainsi que de les générer le plus efficacement possible tout en contraignant certains paramètres." +
      " Une autre classe que j'étudie est celle des graphes ordonnés dirigés acycliques (DOAGs). Pour cette structure, je cherche à déterminer leur asymptotique ainsi que d'étudier la proportion de certains paramètres." +
      " Enfin, je m'interesse également à la génération par unranking lexicographique d'objets combinatoire plus simples tels que les partitions d'ensembles ou d'entiers.",
    links: {
      sorbonne: "https://www-apr.lip6.fr/~genitrini/index2.html",
    },
  },
  preprints:{
    title: "Préprints",
    bib_copy: "Copier",
bib_copied: "Copié",
bib_close: "Fermer",
list: [
      {
        title: "Lexicographic Unranking Algorithms for the Twentyfold Way",
        authors: "Coécrit avec Antoine Genitrini",
        description: "Préprint", 
        pdfUrl: "https://hal.science/hal-05486059v1",
        date : "Février 2025", 
        bibtex: `@unpublished{curiel:hal-05486059,
  TITLE = {{Lexicographic unranking algorithms for the Twentyfold Way}},
  AUTHOR = {Curiel, Amaury and Genitrini, Antoine},
  URL = {https://hal.science/hal-05486059},
  NOTE = {working paper or preprint},
  YEAR = {2026},
  KEYWORDS = {Twentyfold Way ; Twelvefold Way ; Unranking ; Combinatorial generation ; Lexicographic order ; Thirtyfold Way},
  PDF = {https://hal.science/hal-05486059v1/file/CurielGenitrini_vHAL.pdf},
  HAL_ID = {hal-05486059},
  HAL_VERSION = {v1},
}`
      },]
  },
  featuredPublications: {
    title: "Publications (Conférences et Journaux)",
    bib_copy: "Copier",
    bib_copied: "Copié",
    bib_close: "Fermer",
    list: [


      {
        title: "Lexicographic Unranking Algorithms for the Twelvefold Way",
        authors: "Coécrit avec Antoine Genitrini",
        description: "Publié dans les actes de [aofa: AofA 2024]",
        pdfUrl:
          "https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17",
        videoUrl: "https://www.youtube.com/watch?v=g6HHldZHgp0",
        diapourl: "/assets/pres_AofA.pdf",
        date: "Juin 2024",
        links: {
          aofa: "https://www.math.aau.at/AofA/",
        },
        bibtex: `@InProceedings{curiel_et_al:LIPIcs.AofA.2024.17,
  author =	{Curiel, Amaury and Genitrini, Antoine},
  title =	{{Lexicographic Unranking Algorithms for the Twelvefold Way}},
  booktitle =	{35th International Conference on Probabilistic, Combinatorial and Asymptotic Methods for the Analysis of Algorithms (AofA 2024)},
  pages =	{17:1--17:14},
  series =	{Leibniz International Proceedings in Informatics (LIPIcs)},
  ISBN =	{978-3-95977-329-4},
  ISSN =	{1868-8969},
  year =	{2024},
  volume =	{302},
  editor =	{Mailler, C\'{e}cile and Wild, Sebastian},
  publisher =	{Schloss Dagstuhl -- Leibniz-Zentrum f{\"u}r Informatik},
  address =	{Dagstuhl, Germany},
  URL =		{https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17},
  URN =		{urn:nbn:de:0030-drops-204522},
  doi =		{10.4230/LIPIcs.AofA.2024.17},
  annote =	{Keywords: Twelvefold Way, Set partitions, Unranking, Lexicographic order}
}
        `,
      },
    ],
  },
  experiencePage: {
    title: "Curriculum Vitae",
    rexp : {
      title: "Expériences en recherche",
      timeline: [
            {
          institution: "Sorbonne Université, LIP6",
          role: "Doctorant en informatique",
          location: "Paris, France",
          date: "2024 – aujourd’hui",
          description: "Thèse: Combinatorics of Binary Decision Diagrams (BDD)",
          type: "work",
        },
        {
          institution: "LIP6",
          role: "Stage de recherche (6 mois)",
          location: "Paris, France",
          date: "Juillet-Aout 2024",
          description: "Énumération et unranking de ZDDs par profil.",
          type: "work",
        },
        {
          institution: "LIP6",
          role: "Stage volontaire de recherche (2 mois)",
          location: "Paris, France",
          date: "Juin-Juillet 2023",
          description:
            "Génération par unranking lexicographique de partitions d'ensembles.",
          type: "work",
        }

      ]
    },
    parcours: {
      title: "Parcours académique",
      timeline: [
    
        {
          institution: "Sorbonne Université",
          role: "Master informatique, parcours Sciences et Technologies du Logiciel (STL)",
          location: "Paris, France",
          date: "2022-2024 — mention Bien",
          description:
            "Master spécialisé dans l'algorithmique, la programmation et le génie logiciel.",
          type: "education",
        },

        {
          institution: "Université Paris-Saclay",
          role: "Double licence Mathématiques et Informatique",
          location: "Orsay, France",
          date: "2019 – 2022",
          description: "Formation en mathématiques et en informatique.",
          type: "education",
        },
      ],
    },
    skills: {
      programming: {
        title: "Paradigmes de programmation",
        list: [
          {
            name: "Concurrent",
            language: [
              {
                name: "Go",
                logo: "assets/go_logo.png",
              },
            ],
          },
          {
            name: "Fonctionnel",
            language: [
              {
                name: "OCaml",
                logo: "assets/ocaml_logo2.png",
              },
              {
                name: "Haskell",
                logo: "assets/haskell_logo.png",
              },
            ],
          },
          {
            name: "Orienté objet",
            language: [
              {
                name: "Java",
                logo: "assets/java_logo.png",
              },
              {
                name: "C++",
                logo: "assets/cpp_logo.png",
              },
              {
                name: "Python",
                logo: "assets/python_logo.png",
              },
            ],
          },
          {
            name: "Impératif",
            language: [
              {
                name: "C",
                logo: "assets/c_logo.png",
              },
            ],
          },
          {
            name: "Assistants de preuve",
            language: [
              {
                name: "Coq/Rocq",
                logo: "assets/coq_logo.png",
              },
              {
                name: "Lean4",
                logo: "assets/lean_logo.svg",
              },
            ],
          },
        ],
      },
      competences: {
        title: "Compétences",
        list: [
          {
            title: "Algorithmes",
            list: [
              {
                name: "Conception",
              },
              {
                name: "Implémentation",
              },
              {
                name: "Analyse",
              },
              {
                name: "Test de performances en pratique",
              },
            ],
          },
          {
            title: "Mathématiques",
            list: [
              {
                name: "Analyse",
              },
              {
                name: "Probabilités",
              },
              {
                name: "Combinatoire analytique",
              },
            ],
          },
          {
            title: "Développement de logiciels",
            list: [
              {
                name: "CI/CD",
              },
              {
                name: "Tests",
              },
              {
                name: "Architecture",
              },
            ],
          },
          {
            title: "Analyse de programmes",
            list: [
              {
                name: "Compilation",
              },

              {
                name: "Model checking",
              },
              {
                name: "Interpretation abstraite",
              },
            ],
          },
        ],
      },
      languages: {
        title: "Langues vivantes",
        list: [
          {
            name: "Français",
            level: "Langue maternelle",
            flag: "assets/fr_flag.png",
          },
          {
            name: "Espagnol",
            level: "Courant",
            flag: "assets/es_flag.png",
          },
          {
            name: "Anglais",
            level: "Courant",
            flag: "assets/en_flag.png",
          },

          {
            name: "Chinois mandarin",
            level: "HSK 2, HSK 3 en préparation",
            flag: "assets/zh_flag.png",
          },
          {
            name: "Russe",
            level: "A1",
            flag: "assets/ru_flag.png",
          },
        ],
      },
    },
  },
  teaching: {
    title: "Enseignements",
    ues: [
      {
        title: "Analyse d'algorithmes & génération aléatoire",
        level: "Master 2",
        participation: "Cours, TD & TP",
        year: "2024",
        description:
          "Génération aléatoire de nombres, de structures simples et de graphes. ",
        ressources: [
          {
            title: "Diapos",
            url: "/assets/diapos_aaga.pdf",
          },

        ],
      },
      {
        title: "Mathématiques discrètes",
        level: "Licence 2",
        participation: "TP",
        year: "2024",
        description: "Implémentation d'une bibliothèque d'automates en python",
      },
      {
        title: "Mathématiques discrètes",
        level: "Licence 2",
        participation: "TD, TP",
        year: "2025",
        description: "L'objectif de ce cours est de présenter les outils mathématiques qui sont à la base des techniques utilisées dans la plupart des domaines de l'informatique. En particulier, plusieurs des notions vues sont en lien avec les problèmes de terminaison de programme, la récursion et la compilation, l'autre thème abordé étant celui de la logique. ",
      },
      {
        title: "Algorithmique Avancée",
        level: "Master 1",
        participation: "TD",
        year: "2025",
        description:
          "L'objectif de ce cours, est de montrer comment l'utilisation de structures de données avancées permet d'optimiser les performances des algorithmes dans des domaines d'application variés comme la gestion et la compression de données massives.",
      },
      {
        title: "Structures de données avancées",
        level: "Licence 2",
        participation: "TD & TP",
        year: "2025",
        description:
          "Programmations de structures de données (listes, tables de hachage, arbres et graphes) en C & conception d'algorithmes sur ces structures.",
      },
      {
        title: "Projet STL",
        level: "Master 1",
        participation: "Encadrant",
        year: "2025",
        description:
          "Encadrement d'un groupe de 2 étudiants. Conception, état de l'art et implémentation d'algorithmes de génération lexicographiques par unranking pour chacun des 12 problèmes de Rota.",
        ressources: [
          {
            title: "Sujet",
            url: "assets/sujet.pdf",
          },
        ],
      },

      {
        title: "Vulgarisation : Reproduction du jeux Space Invaders",
        level:
          "Accueil d'élèves de 3ème dans le cadre de leurs stage obligatoire",
        participation: "Conception et animation de l'activité",
        year: "2025",
        month: "Mars",
        description:
          "Introduction à la programmation en python. Reproduction du jeu Space Invaders.",
        ressources: [
          {
            title: "Sujet",
            url: "assets/activite.pdf",
          },
        ],
      },
    ].sort((a, b) => {
      if (a.year === b.year) {
        return Number(b.month ?? 0) - Number(a.month ?? 0);
      } else {
        return b.year - a.year;
      }
    }),
  },
  expose: {
    title: "Exposés",
    list: [
      {
        title:
          "Algorithmes d'unranking lexicographiques pour les 20 problèmes de Bogart",
        event: "Journées d'équipe APR",
        date: "Juin 2025",
        ressources: [
          {
            title: "Diapos",
            url: "assets/pres_apr2.pdf",
          },
        ],
      },
      {
        title: "Énumération des BDDs par profil",
        event: "Workshop Pandag",
        date: "Mai 2025",
        ressources: [
          {
            title: "Diapos",
            url: "assets/pres.pdf",
          },
          {
            title: "Abstract",
            url: "assets/abstract_fr.pdf",
          },
        ],
      },
      {
        title: "Unranking des ZDD",
        event: "Journées d'équipe APR",
        date: "Juin 2024",
        ressources: [
          {
            title: "Diapos",
            url: "assets/pres_apr.pdf",
          },
          {
            title: "Abstract",
            url: "assets/abstract_apr.pdf",
          },
        ],
      },
      {
        title:
          "Algorithmes d'unranking lexicographique pour les 12 problèmes de Rota",
        event: "AofA 2024",
        date: "Juin 2024",
        ressources: [
          {
            title: "Diapos",
            url: "assets/pres_AofA.pdf",
          },
          {
            title: "Article",
            url: "https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17",
          },
          {
            title: "Vidéo",
            url: "https://www.youtube.com/watch?v=g6HHldZHgp0",
          },
        ],
      },
    ],
  },
  software: {
    title: "Logiciels",
    list: [
      {
        name: "setpartition_unrank",
        language: "Go",
        logo: "assets/go_logo.png",
        description:
          "Librairie permettant de générer des partitions d'ensembles par unranking lexicographique. Cette implémentation utilise le paradigme concurent de Go pour être efficace en mémoire sans sacrifier de temps d'execution.",
        url: "https://pkg.go.dev/github.com/AMAURYCU/setpartition_unrank",
      },
      {
        name: "ZDD Generator",
        language: "Go",
        logo: "assets/go_logo.png",
        description:
          "Librairie Go permettant de générer par unranking des ZDDs d'un profil donné. Le profil peut également être généré par unranking. Cette librairie permet également de générer des ROBDDs en générant un ZDD puis en lui appliquant une transformation bijective.",
      },
      {
        name: "Rota engine",
        language: "Python",
        logo: "assets/python_logo.png",
        description:
          "Ensemble de fichiers python permettant de générer par unranking (ordre combinatoire ou lexicographique) les objets décrits par Kenneth P. Bogart dans ces Twentyfold ways.",
        url: "https://github.com/AMAURYCU/Unranking_of_partitions"
      },
    ],
    default: "Bientôt disponible",
    visit: "Voir plus",
  },
};
